interface PersonaNames {
  personaTitle?: string | null;
  segmentName?: string | null;
}

/**
 * Whether a persona's title says something its segment name does not. A persona generated from
 * an IQ segment carries the segment name as its title, so showing both would repeat it.
 */
export const isDistinctTitle = ({ personaTitle, segmentName }: PersonaNames): boolean => {
  const title = personaTitle?.trim();
  const segment = segmentName?.trim();
  return Boolean(title && segment && title.toLowerCase() !== segment.toLowerCase());
};

export const personaLabel = (names: PersonaNames, separator = ': '): string => {
  const title = names.personaTitle?.trim();
  const segment = names.segmentName?.trim();
  return isDistinctTitle(names) ? `${title}${separator}${segment}` : title || segment || '';
};
